import { render, staticRenderFns } from "./dragDropEmailFooterBlock.vue?vue&type=template&id=2fac3125&"
import script from "./dragDropEmailFooterBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropEmailFooterBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports